import {Component, inject} from '@angular/core';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MatListItem, MatListItemTitle, MatNavList} from '@angular/material/list';
import {MatLine} from '@angular/material/core';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-select-type-file-bottomsheet',
  imports: [
    MatNavList,
    MatListItemTitle,
    MatLine,
    MatListItem,
    MatIcon
  ],
  templateUrl: './select-type-file-bottomsheet.component.html',
  styleUrl: './select-type-file-bottomsheet.component.scss'
})
export class SelectTypeFileBottomsheetComponent {
  private _bottomSheetRef =
    inject<MatBottomSheetRef<SelectTypeFileBottomsheetComponent>>(MatBottomSheetRef);

  openLink(type: string): void {
    this._bottomSheetRef.dismiss(type);
  }

  closeBottomSheet() {
    this._bottomSheetRef.dismiss();
  }
}
